import { CRM } from "@/components/atomic-crm/root/CRM";

/**
 * Application entry point
 *
 * Customize Atomic CRM by passing props to the CRM component:
 *  - companySectors
 *  - darkTheme
 *  - dealCategories
 *  - dealPipelineStatuses
 *  - dealStages
 *  - lightTheme
 *  - darkModeLogo / lightModeLogo
 *  - noteStatuses
 *  - taskTypes
 *  - title
 * ... as well as all the props accepted by shadcn-admin-kit's <Admin> component.
 *
 * Logos must be an imported asset, an absolute URL, or a data URI — never a
 * route-relative path like "./img/logo.png", which breaks on nested routes.
 *
 * @example
 * import logoDark from "./logo-dark.svg";
 * import logoLight from "./logo-light.svg";
 *
 * const App = () => (
 *    <CRM
 *       darkModeLogo={logoDark}
 *       lightModeLogo={logoLight}
 *       title="Acme CRM"
 *    />
 * );
 */
// Walnut Pages: one Company per Prospect, its owner address as the Contact,
// one Deal per Pitch (Mockup link in the description), and Follow-up and
// Clock tasks for the 7-day follow-up and the 90-day silence rule, and a
// Takedown task on the date the follow-up names (remodel_sites
// docs/outreach.md).
const App = () => (
  <CRM
    title="Walnut Pages CRM"
    disableTelemetry
    companySectors={[
      { value: "venue", label: "Event venue" },
      { value: "bar", label: "Bar" },
      { value: "restaurant", label: "Restaurant" },
      { value: "salon", label: "Salon" },
      { value: "other", label: "Other" },
    ]}
    dealStages={[
      { value: "mockup-built", label: "Mockup built" },
      { value: "pitch-sent", label: "Pitch sent" },
      { value: "talking", label: "Talking" },
      { value: "won", label: "Won" },
      { value: "declined", label: "Declined" },
    ]}
    dealPipelineStatuses={["won"]}
    dealCategories={[{ value: "website", label: "Website" }]}
    taskTypes={[
      { value: "follow-up", label: "Follow-up" },
      { value: "clock", label: "Clock ends" },
      { value: "takedown", label: "Takedown" },
      { value: "pre-send", label: "Pre-send check" },
      { value: "email", label: "Email" },
      { value: "call", label: "Call" },
      { value: "none", label: "Other" },
      { value: "claude", label: "Claude" },
    ]}
  />
);

export default App;
